import { twMerge } from 'tailwind-merge';

interface Props {
  className?: string;
  numDots?: number;
  style?: 'bounce' | 'pulse';
}

export function LoadingDots(props: Props) {
  const numDots = props.numDots || 3;

  return (
    <div
      className={twMerge(
        props.className,
        'flex',
        'items-center',
        'justify-center',
        'gap-x-[0.25em]',
      )}
    >
      {Array.from({ length: numDots }).map((_, i) => (
        <div
          key={i}
          className={twMerge(
            props.style === 'bounce'
              ? 'animate-staggered-bounce'
              : 'animate-pulse',
            'bg-current',
            'flex-shrink-0',
            'h-[0.33em]',
            'rounded-full',
            'w-[0.33em]',
          )}
          style={{
            animationDelay: `${i * 200}ms`,
          }}
        />
      ))}
    </div>
  );
}
